import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBSHKCPvzmcca2dxpAtC3atqwF7STYEIlk",
  authDomain: "tube2blog-eb318.firebaseapp.com",
  projectId: "tube2blog-eb318",
  storageBucket: "tube2blog-eb318.appspot.com",
  messagingSenderId: "821062683685",
  appId: "1:821062683685:web:bf4387ed69a4c079a583cc",
  measurementId: "G-JBBXJBWC5D",
};

const firebase = initializeApp(firebaseConfig);
const auth = getAuth(firebase);

const db = getFirestore(firebase);
export { firebase, auth, db };
